import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Auth } from 'src/app/models/auth';
import { FilterUseProducts } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import {saveAs} from 'file-saver';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-extrato-relatorio',
  templateUrl: './extrato-relatorio.component.html',
  styleUrls: ['./extrato-relatorio.component.css']
})
export class ExtratoRelatorioComponent implements OnInit {
  
  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    public datepipe: DatePipe
  ) { }
  
  public currentUser: Auth;
  public filtro = new FilterUseProducts(null,null,null,null,null,false);
  
  public startDateCtrl: FormControl = new FormControl();
  public endDateCtrl: FormControl = new FormControl();

  public dataInicio = new Date();
  public dataFim = new Date();
  public dataMaxima = new Date();
  queryDate: Date;
  
  public extrato: any;
  public filtroOn: boolean = false;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.dataInicio.setDate(this.dataInicio.getDate()-90);
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;

    this.carregarRelatorio(1);
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.GetAssignorExtract(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.extrato = response.result.assignorExtract;
        this.totalItems = response.result.total;
        this.queryDate = new Date();
      }
    });
  }  

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  setPeriod(inicio,date: Date){
    if(inicio){
      this.filtro.dateStart = date;
      this.dataMaxima = new Date(date.getFullYear(), date.getMonth(), date.getDate()+90);
      if (this.filtro.dateEnd >= this.dataMaxima){
        this.filtro.dateEnd = this.dataMaxima;
      } else if (this.filtro.dateEnd < this.filtro.dateStart){
        this.filtro.dateEnd =  this.filtro.dateStart;
      }
    } else {
      this.filtro.dateEnd = date;
    }
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }
  
  applyFilter() {
    if(
      this.filtro.dateStart == this.dataInicio &&
      this.filtro.dateEnd == this.dataFim
    ){
      this.filtroOn = false;
      this.carregarRelatorio(1);
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
    }
  }

  deleteFilter(){
    this.filtro.dateStart = this.dataInicio;
    this.filtro.dateEnd = this.dataFim;

    this.filtroOn = false;

    this.carregarRelatorio(1);
  }

  exportExtractExcel(){
    var result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const excelService = new ExcelService();
    const worksheets = new Array<WorksheetData>();
    const ws = new WorksheetData();
    ws.worksheetTitle = 'relatorio_extrato_' + date[2] + '-' + date[1] + '-' + date[0];
    ws.worksheetHeaders = ['Origem','Destino','Produto','Descritivo da Transação','Data e hora','Valor'];
    ws.WorksheetRows = [];
    // /*
    this.relatorioService.GetAssignorExtract(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.assignorExtract;
      
        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(r.origin);
          lr.push(r.receiver);
          lr.push(r.product);
          lr.push(r.descriptionTransaction );
          lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm'));
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          ws.WorksheetRows.push(lr);
        });

        worksheets.push(ws);

        let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');

        excelService.generateExcelReport('Relatório de extrato', worksheets, filter).xlsx
        .writeBuffer().then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, ws.worksheetTitle + '.xlsx');
        });

      }
    },
    error => {
      this.alertService.error('Ocorreu um erro ao paginar relatorio');
    });
    // */
  }

  exportExtractPdf(){
    let result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const pdfData = new PdfData();
    pdfData.PdfTitle = 'relatorio_extrato_' + date[2] + '-' + date[1] + '-' + date[0];
    pdfData.PdfHeaders = ['Origem','Destino','Produto','Descritivo da Transação','Data e hora','Valor',''];
    pdfData.PdfRows = [];

    this.relatorioService.GetAssignorExtract(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.assignorExtract;

        result.forEach((r) => {
            const lr = new Array<string>();
            lr.push(r.origin);
            lr.push(r.receiver);
            lr.push(r.product);
            lr.push(r.descriptionTransaction );
            lr.push(this.datepipe.transform(r.date, 'dd/MM/yyyy HH:mm'));
            lr.push('R$');
            lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
            pdfData.PdfRows.push(lr);
        });

        let filter = 'Data inicio: ' + this.datepipe.transform(this.filtro.dateStart, 'dd/MM/yyyy') + ' - Data fim: ' + this.datepipe.transform(this.filtro.dateEnd, 'dd/MM/yyyy');

        const pdfService = new PdfService();
        pdfService.generatePdfReport('Relatório de extrato',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss'),true).getBlob((blob) => {
          saveAs(blob, pdfData.PdfTitle + '.pdf');
        });

      } else {
        this.alertService.error(response.message);
      }
    },
    error => {
      this.alertService.error(
        'Ocorreu um erro ao paginar o relatorio'
      );
    });
  }

  formatarCpf(cpf){
    if(cpf == null)
      return null
      
    const tam = environment.TOTAL_CARACTERE_CPF - cpf.toString().length;

    for (let i = 0; i < tam; i++) { cpf = '0' + cpf; }

    return cpf.slice(0,3)+"."+cpf.slice(3,6)+"."+cpf.slice(6,9)+"-"+cpf.slice(9);
  }

}

